var map = {
	"./1577_appdata.json": 27737,
	"./1577_appdata_v2.json": 44266,
	"./1577_appdata_v3.json": 67349,
	"./1577_appdata_v4.json": 69172,
	"./1577_appdata_v5.json": 63559,
	"./lobbyrooms.json": 89285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49006;